import React, { useState }  from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import ConfirmationModal from '../components/ConfirmationModal';
import green from '@material-ui/core/colors/green';
import { DealerService } from '../services';
import { useError } from '../contexts/ErrorContext';

const styles = makeStyles(() => ({
    submitButton: {
        marginLeft: '10px',
        marginTop: '25px'
    },
    confirmButton: {
        backgroundColor: green[400],
        float: 'right',
        marginTop:'16px',
        marginRight:'4px'

    },
    inputAmount: {
        float: 'right',
        marginTop: '8px',
        marginRight:'4px',
        marginBottom: '4px'
    }
}));

const RefreshDealerMaterializedView = (props) => {
    const { showError } = useError();
    const [showConfirmConfirmationBox, setShowConfirmConfirmationBox] = useState(false);
    const toggleConfirmConfirmation = () => setShowConfirmConfirmationBox(!showConfirmConfirmationBox);

    const handleConfirmRefreshButtonClick = async (event) => {
        toggleConfirmConfirmation();
    }
    
    const handleConfirmRefreshButton = async (event) => {
        DealerService.refreshDealerMetric().catch(showError);
        toggleConfirmConfirmation();
    }

    const classes = styles();
    return(
        <div>
            <ConfirmationModal title="Confirm" message="Are you sure you want to refresh dealer's matierialized view?" onConfirm={handleConfirmRefreshButton} onCancel={toggleConfirmConfirmation} showConfirmationBox={showConfirmConfirmationBox}/>

            <Button variant="contained"
            className={classes.confirmButton}
            onClick={handleConfirmRefreshButtonClick}
            >submit
            </Button>

        </div>
    )
}

export default RefreshDealerMaterializedView;